<template>
  <div>
    <!-- <div class="header">
      <div class="title">
        <div @click="goBack()" class="img"><img src="@/assets/images/back.png" alt=""></div>
        <div>赛队介绍</div>
      </div> -->
    <img class="bg-img" src="https://iogw.cgo.ink:9000/hgzpub/pic/calendar/recopic2@3x.webp" />
    <!-- </div> -->
    <div class="box">
      <div class="card-box">
        <!-- <div class="card-title">{{ dataInfo.title }}</div> -->
        <div class="content">
          <img class="content-img" src="https://iogw.cgo.ink:9000/hgzpub/pic/calendar/reco2@3x.webp" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
      created() {
        this.dataInfo = {
            title: '用户隐私协议',
            content: `敬请期待！`
        }
      },
      mounted() {},
      data() {
          return {
            dataInfo: {}
          }
      },
      methods: {
        goBack() {
          this.$router.go(-1)
        }
      },
      computed: {},
      watch: {},
      filters: {},
      components: {}
  }
  </script>

  <style lang="scss" scoped>
  .bg-img{
      width: 100%;
    }
  .header{
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-family: PingFangSC-Regular;
    font-size: 15px;
    color: #333333;
    background-color: #fff;
    .title{
      width: 100%;
      height: 44px;
      margin-top: 44px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 800;
      font-size: 18px;
      color: #333;
      line-height: 34px;
      text-align: left;
      font-style: normal;

      .img{
        img{
          height: 20px;
        }
        position: absolute;
        left: 16px;
        top: 40px;
      }
    }
  }
  .box{
    background: #FFFFFF;
    padding: 8px;
    min-height: calc(100vh - 214px);
    // border-radius: 10px 10px 0 0;
    // position: relative;
    // top: -30px;
    // z-index: 110;
  }
  .card-box{
    width: 100%;
    background: #FFFFFF;
    // box-shadow: 0px 2px 8px 0px rgba(222,229,243,0.3);
    // padding: 6px 10px;
    // border-radius: 6px;
    .content{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        padding-top: 8px;
        .content-img{
          width: 100%;
        }
    }
}
</style>
